import { SelectInput } from "@dzambalaorg/mui-inputs-core";
import { ClaimStatus, ClaimType, type IClaimSearchDto } from "@framework/types";
import { SearchWithFilters } from "@dzambalaorg/mui-form-search";
import { FormGrid } from "@dzambalaorg/ui-kit";

interface IClaimSearchFormProps {
  initialValues: Partial<IClaimSearchDto>;
}

export const ClaimSearchForm = (props: IClaimSearchFormProps) => {
  const { initialValues } = props;

  return (
    <SearchWithFilters initialValues={initialValues}>
      <FormGrid columns={[2]} containerProps={{ sx: theme => ({ marginTop: theme.spacing(theme.tokens.spacing.xl) }) }}>
        <SelectInput multiple name="claimStatus" options={ClaimStatus} />
        <SelectInput multiple name="claimType" options={ClaimType} />
      </FormGrid>
    </SearchWithFilters>
  );
};
